@if (visible()) {
    <button type="button" class="anchor" (click)="onClick($event)">
        {{ label() }}
    </button>
}
